module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.5.7@core-js/library/modules/_add-to-unscopables.js
// module id = 6OxN
// module chunks = 0